import React from 'react';
import './MainSection5.css'; // Make sure to create a corresponding CSS file
// import { Link } from 'react-router-dom';

const MainSection5 = () => {
  return (
    <section className="section-5">
      <img src="/images/App_download_banner.avif" alt="Download Banner" />
    </section>
  );
}

export default MainSection5;
